module.exports = __webpack_public_path__ + "static/media/logo-alt.b7394192.png";